/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tree_CollapseInputs */

const en_tree_collapse = /** @type {(inputs: Tree_CollapseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collapse sub-items`)
};

const de_tree_collapse = /** @type {(inputs: Tree_CollapseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untervorgänge einklappen`)
};

/**
* | output |
* | --- |
* | "Collapse sub-items" |
*
* @param {Tree_CollapseInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tree_collapse = /** @type {((inputs?: Tree_CollapseInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tree_CollapseInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tree_collapse(inputs)
	return en_tree_collapse(inputs)
});